module.exports = __webpack_public_path__ + "img/w69.18a40c5a.svg";